import axios from "axios";
import { TDS_auth } from "../utils/auth";

const api = axios.create({
  baseURL: "https://home.thomasdye.net/api/",            // all calls go through your PHP middleware
  timeout: 15000,
});

api.interceptors.request.use((config) => {
  const token = TDS_auth();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
